module.exports = __webpack_public_path__ + "static/tactics_notebook_tablet_basket-b8c449008bfc90b0e51c2f2cb5f41e40.mp4";